import React from 'react';
import { Link } from 'react-router-dom';
import ThreadStatusBadges from '../../../components/ThreadStatusBadges/ThreadStatusBadges';
import styles from '../Dashboard.module.css';

const DashboardThreadRow = ({ thread }) => {
  return (
    <Link to={`/threads/${thread.slug || thread.id}`} className={styles.threadRow}>
      <div className={styles.threadRowMain}>
        <span className={styles.threadTitle}>{thread.title}</span>
        <div className={styles.threadMeta}>
          {thread.author?.pseudo && <span>{thread.author.pseudo}</span>}
          {thread.updatedAt && (
            <span>{new Date(thread.updatedAt).toLocaleDateString('fr-FR')}</span>
          )}
          {thread.universe?.name && <span>{thread.universe.name}</span>}
        </div>
      </div>
      <div className={styles.threadRowBadges}>
        <ThreadStatusBadges thread={thread} />
        {thread.postCount != null && (
          <span className={styles.postCount}>{thread.postCount} posts</span>
        )}
      </div>
    </Link>
  );
};

export default DashboardThreadRow;
